import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '@usimweb/core/models';

@Component({
    selector: 'usimweb-menu',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent {
  @Input() menuItems: MenuItem[] = [];

  @Input() uuid: string = '';

  @Output() eventEmitterItemClicked: EventEmitter<any> = new EventEmitter<any>();

  public checked = false;

  public itemClicked(item: string, event: boolean) {
    this.checked = event;
    this.eventEmitterItemClicked.emit({
      item: item,
      event: this.checked,
      uuid: this.uuid,
    });
  }
}
